module.exports = __webpack_public_path__ + "d5c04557c3ef6dab9fedadd324e32e23.png";